import React, { Fragment, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import step1 from '../componentes/steps/step1.svg';
import step3 from '../componentes/steps/step3.svg';
import step4 from '../componentes/steps/step4.svg';


const steps = [
    { step: 1, text: 'Download the APP.', image: step1, style: { top: -15, right: 0, left: 0} },
    { step: 2, text: 'Sign up.', image: step3, style: { top: 0, right: -15, bottom: 0 } },
    { step: 3, text: 'Use the APP and receive incentives.', image: step4, style: { top: 0, left: -15, bottom: 0 } },

]

const AboutCirc = () => {
    const [ currentStep, setCurrentStep ] = useState(1);

    return (
        <Fragment theme='' id="users_about" epicBarDirection="left">
            <div className=" padSec users-c">
                <Row className="">
                    <Col md={6} className="offset-0 xcenter pad-all-40 pad-right-80 user-right" style={{paddingRight:"40px"}}>
                        <div className="about-image-container" proportional="square, static" style={{height:"415px", width:"415px"}}>
                            {
                                steps.map(item => {
                                return (
                                    <span
                                    key={item.step}
                                    onMouseEnter={() => setCurrentStep(item.step)}
                                    className="about-step-dot"
                                    style={{ ...item.style, width: currentStep === item.step ? 30 : 25, height: currentStep === item.step ? 30 : 25 }}
                                    >
                                    </span>
                                );
                                })
                            }
                            <img src={steps[currentStep -1 ].image} style={{ width: '60%' }}/>
                        </div>
                    </Col>
                    <Col md={6} className="user-left" style={{padding:"40px"}}>
                        <Row className=" ">
                            <Col md={12} className="">
                                <h2 className=" title c-white mrg-bt-10 line-height-title letter-spacing-3px mrg-right-60 fw-black x:fs-30 fs-60 titleStart">
                                    <span className="fw-light">
                                        HOW IT
                                    </span> 
                                    <br/> 
                                    WORKS?
                                </h2>
                            </Col>
                            <Col md={12}  className="">
                                <ol className="about-steps-list" style={{marginTop:"20px"}}>
                                    {
                                    steps.map(item => {
                                        return (
                                        <li
                                            key={item.step}
                                            onMouseEnter={() => setCurrentStep(item.step)}
                                            className={ currentStep === item.step ? 'fw-bold c-blue fs-20 s:fs-22 fs-24' : 'f-18 fs-20' }
                                        >
                                            {item.text}
                                        </li>
                                        );
                                    })
                                    }
                                </ol>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </Fragment>
    )
}

export default AboutCirc;
